module.exports = __webpack_public_path__ + "assets/img/Inter-Black.svg?3e836fb0518975616def21083f491062";